
import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./fixedLocker.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.fixedLockerAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getFixedLockerAddress = () => {
    return contractAddress;
}

const getFixedLockerContract = () => {
    return contractConst.contract;
}

const getFixedLockerInfo = ([_pid], options) => {
    return $web3js.call(
        getFixedLockerContract().methods.getPoolInfo, [_pid], options,
        handlFixedLockerInfo
    );
};

const handlFixedLockerInfo = async(res) => {

    let index = 0;
    let pid = res[index++];
    let issueId = res[index++];
    let lockedDays = res[index++];
    let startTime = res[index++];
    let pledgePeriod = res[index++];
    let endPledgeTime = res[index++];
    let limitCount = res[index++];
    let maxAmount = res[index++];
    let depositAmount = res[index++];
    let withdrawAmount = res[index++];
    let estimateBenefit = res[index++];
    let gainedBlock = res[index++];
    let unlockedBenefit = res[index++];
    let withdrawnBenefit = res[index++];
    let mvtRatio = res[index++];
    let mvtAmount = res[index++];
    let pledgeToken = res[index++];
    let benefitToken = res[index++];
    let apy = res[index++];
    let state = res[index++];
    let endPledgeBlock = res[index++];
    let reserved1 = res[index++];
    let reserved2 = res[index++];
    let reserved3 = res[index++];
    let reserved4 = res[index++];
    let reserved5 = res[index++];


    maxAmount = await $erc20.fromErc20Value(maxAmount, pledgeToken);
    depositAmount = await $erc20.fromErc20Value(depositAmount, pledgeToken);
    withdrawAmount = await $erc20.fromErc20Value(withdrawAmount, pledgeToken);

    return {
        issueId,
        lockedDays,
        endPledgeTime,
        maxAmount,
        depositAmount,
        withdrawAmount,
        state

    };
};

const getFixedLockerCalcLockInfo = async([_pid, _amount, _contractAddress], options) => {
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.call(
        getFixedLockerContract().methods.calcLockInfo, [_pid, _amount], options,
        handlCalcLockInfo, [_contractAddress]
    );
};

const handlCalcLockInfo = async(res, _contractAddress) => {


    let index = 0;
    let remainLock = res[index++];
    let balance = res[index++];
    let mvtAmount = res[index++];
    let estimateBenefit = res[index++];
    let reaminCount = res[index++];


    remainLock = await $erc20.fromErc20Value(remainLock, _contractAddress);
    balance = await $erc20.fromErc20Value(balance, _contractAddress);
    mvtAmount = await $web3js.fromWei(mvtAmount);
    estimateBenefit = await $erc20.fromErc20Value(estimateBenefit, _contractAddress);

    return {
        remainLock,
        balance,
        mvtAmount,
        estimateBenefit,
        reaminCount

    };
};


const getFixedLockerUserInfos = ([_user], options) => {
    return $web3js.call(
        getFixedLockerContract().methods.getUserInfos, [_user], options,
        handlFixedLockerUserInfos
    );
};

const handlFixedLockerUserInfos = async(res2) => {

    let resList = [];
    if (res2.length > 0) {
        for (let res of res2) {
            let index = 0;
            let pid = res[index++];
            let issueId = res[index++];
            let lockedDays = res[index++];
            let depositAmount = res[index++];
            let withdrawAmount = res[index++];
            let unlockedBenefit = res[index++];
            let withdrawnBenefit = res[index++];
            let lockedCount = res[index++];
            let mvtAmount = res[index++];
            let unlockedAmount = res[index++];
            let pledgeToken = res[index++];
            let benefitToken = res[index++];
            let apy = res[index++];
            let reserved1 = res[index++];
            let reserved2 = res[index++];
            let reserved3 = res[index++];
            let reserved4 = res[index++];
            let reserved5 = res[index++];

            depositAmount = await $erc20.fromErc20Value(depositAmount, pledgeToken);
            withdrawAmount = await $erc20.fromErc20Value(withdrawAmount, pledgeToken);
            unlockedBenefit = await $erc20.fromErc20Value(unlockedBenefit, benefitToken);
            withdrawnBenefit = await $erc20.fromErc20Value(withdrawnBenefit, benefitToken);
            unlockedAmount = await $erc20.fromErc20Value(unlockedAmount, pledgeToken);
            mvtAmount = await $erc20.fromErc20Value(mvtAmount, $erc20.getErc20Address("MVT"));

            let myLock = Vue.prototype.$numberUtils.sub(depositAmount - withdrawAmount)
            let remainAmount = Vue.prototype.$numberUtils.sub(unlockedAmount - withdrawAmount)
            let Benefit = Vue.prototype.$numberUtils.sub(unlockedBenefit - withdrawnBenefit)
            let item = {
                pid,
                issueId,
                pledgeToken,
                benefitToken,
                lockedDays,
                depositAmount,
                withdrawAmount,
                unlockedBenefit,
                withdrawnBenefit,
                unlockedAmount,
                myLock,
                remainAmount,
                Benefit,
                mvtAmount,
                apy

            }
            resList.push(item);

        }
    }
    return resList;

};

const fixedLockerUserDeposit = async([_pid, _amount, _contractAddress], options, callback) => {
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.send(getFixedLockerContract().methods.lock, [_pid, _amount], options, callback);
};

const fixedLockerUserDepositEstimateSend = async([_pid, _amount, _contractAddress], options) => {

    _amount = await $erc20.toErc20Value(_amount, _contractAddress);


    let gasPromise = $web3js.estimateSend(getFixedLockerContract().methods.lock, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const currentLockerUserRedeem = async([_pid, _amount, _contractAddress], options, callback) => {

    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    return $web3js.send(getCurrentLockerContract().methods.redeem, [_pid, _amount], options, callback);
};

const currentLockerRedeemEstimateSend = async([_pid, _amount, _contractAddress], options) => {

    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let gasPromise = $web3js.estimateSend(getCurrentLockerContract().methods.redeem, [_pid, _amount], options);

    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const fixedLockerWithdraw = ([_pid], options, callback) => {
    return $web3js.send(getFixedLockerContract().methods.withdraw, [_pid], options, callback);
};

const fixedLockerWithdrawEstimateSend = async([_pid], options) => {
    let gasPromise = $web3js.estimateSend(
        getFixedLockerContract().methods.withdraw, [_pid], options
    );
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const getFixedLockerUserReleaseInfo = ([_user, _pid, _contractAddress, _benefitAddress], options) => {
    return $web3js.call(
        getFixedLockerContract().methods.getUserReleaseInfo, [_user, _pid], options,
        handlFixedLockerUserReleaseInfo, [_contractAddress, _benefitAddress]
    );
};

const handlFixedLockerUserReleaseInfo = async(res, _contractAddress, _benefitAddress) => {


    let index = 0;
    let capital = res[index++];
    let availBenefit = res[index++];
    let unlockedBenefit = res[index++];
    let burnMvt = res[index++];


    capital = await $erc20.fromErc20Value(capital, _contractAddress);
    availBenefit = await $erc20.fromErc20Value(availBenefit, _benefitAddress);
    burnMvt = await $erc20.fromErc20Value(burnMvt, $erc20.getErc20Address("MVT"));
    unlockedBenefit = await $erc20.fromErc20Value(unlockedBenefit, _benefitAddress);

    return {
        capital,
        availBenefit,
        unlockedBenefit,
        burnMvt,

    };
};

export default {
    getFixedLockerAddress,
    getFixedLockerContract,
    // getCurrentLockerUserInfo,
    // currentLockerUserDeposit,
    // currentLockerUserDepositEstimateSend,
    // currentLockerUserRedeem,
    // currentLockerRedeemEstimateSend,
    // currentLockerWithdraw,
    // currentLockerWithdrawEstimateSend,
    //
    getFixedLockerInfo,
    getFixedLockerCalcLockInfo,
    fixedLockerUserDeposit,
    fixedLockerUserDepositEstimateSend,
    getFixedLockerUserInfos,
    fixedLockerWithdraw,
    fixedLockerWithdrawEstimateSend,
    getFixedLockerUserReleaseInfo
}



// WEBPACK FOOTER //
// ./src/lib/contract/fixedLocker/index.js